var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCustomSide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31.167,
  height: 23.904
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Custom Side",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 294",
  d: "M14.408 3.294 1.189 8.321v2.523l3.141 2.359-3.662.241v2.438l10.246 7.7 4.186-3.706 3.1 2.529 12.518-8.723v-2.838Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 295",
  d: "m14.408.294-13.262 7.9 3.4 2.492-4.105 2.706 10.486 7.482 4.084-3.306 2.7 1.962 13-8.845Z"
}))));
export default SvgCustomSide;